import React, { Fragment } from "react"
import { StaticImage, GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link, useStaticQuery, graphql } from "gatsby"
import arrow1 from "../../images/arrow-1.png"
import arrow2 from "../../images/arrow-2.png"

export const query = graphql`
  query OthersCompanies {
    KGbio: contentfulOurStakeholdersImages(title: { eq: "KGbio" }) {
      image {
        gatsbyImageData
      }
    }
    Kalbe: contentfulOurStakeholdersImages(title: { eq: "Kalbe" }) {
      image {
        gatsbyImageData
      }
    }
    IGK: contentfulOurStakeholdersImages(title: { eq: "IGK" }) {
      image {
        gatsbyImageData
      }
    }
    KGM: contentfulOurStakeholdersImages(title: { eq: "KGM" }) {
      image {
        gatsbyImageData
      }
    }
    Genexine: contentfulOurStakeholdersImages(title: { eq: "Genexine" }) {
      image {
        gatsbyImageData
      }
    }
    GeneralAtlantic: contentfulOurStakeholdersImages(
      title: { eq: "GeneralAtlantic" }
    ) {
      image {
        gatsbyImageData
      }
    }
  }
`
const OthersCompanies = () => {
  const { KGbio, Kalbe, IGK, Genexine, GeneralAtlantic, KGM } = useStaticQuery(
    query
  )

  return (
    <Fragment>
      <div class="row d-flex justify-content-center" style={{ flexWrap: "unset" }}>
        <div class="col-lg-5 col-md-5 col-sm-12 px-5 pb-4 d-flex justify-content-center align-items-center">
          <div class="icon-bx-wraper center px-5">
            <div class="icon-content">
              <a target="_blank" href="https://www.kalbe.co.id/">
                <GatsbyImage
                  image={getImage(Kalbe.image)}
                  alt="logo-img"
                  className="boxWidth"
                />
              </a>
            </div>
          </div>
        </div>
        {/* <div class="col-lg-5 col-md-5 col-sm-12 px-5 pb-4 d-flex justify-content-center align-items-center">
          <div class="icon-bx-wraper center px-5">
            <div class="icon-content">
              <a target="_blank" href="https://www.generalatlantic.com/">
                <GatsbyImage
                  image={getImage(GeneralAtlantic.image)}
                  alt="logo-img"
                  className="boxWidth"
                />
              </a>
            </div>
          </div>
        </div> */}
        <div class="col-lg-5 col-md-5 col-sm-12 px-5 pb-4 d-flex justify-content-center align-items-center">
          <div class="icon-bx-wraper center px-5">
            <div class="icon-content">
              <a target="_blank" href="http://www.genexine.com/">
                <GatsbyImage
                  image={getImage(Genexine.image)}
                  alt="logo-img"
                  className="boxWidth"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style={{ flexWrap: "unset" }}>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="icon-bx-wraper center">
            <div class="icon-content">
              <img src={arrow2} alt="arrow2" />
            </div>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-lg-8 col-md-8 col-sm-12 px-5 py-5 d-flex justify-content-center align-items-center px-5">
          <div class="icon-bx-wraper center">
            <div class="icon-content">
              <a target="_blank" href="https://www.kg-biologics.com/">
                <GatsbyImage
                  image={getImage(KGbio.image)}
                  alt="logo-img"
                  className="boxWidth"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style={{ flexWrap: "unset" }}>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="icon-bx-wraper center">
            <div class="icon-content">
              <img src={arrow2} alt="arrow2" />
            </div>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-center" style={{ flexWrap: "unset" }}>
        <div class="col-lg-5 col-md-5 col-sm-12 px-5 pt-4 d-flex justify-content-center align-items-center">
          <div class="icon-bx-wraper center px-5">
            <div class="icon-content">
              <a target="_blank" href="http://www.innogene-kalbiotech.com/">
                <GatsbyImage
                  image={getImage(IGK.image)}
                  alt="logo-img"
                  className="boxWidth"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 px-5 pt-4 d-flex justify-content-center align-items-center">
          <div class="icon-bx-wraper center px-5">
            <div class="icon-content">
              <a target="_blank" href="https://www.kalbio.co.id/">
                <GatsbyImage
                  image={getImage(KGM.image)}
                  alt="logo-img"
                  className="boxWidth"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default OthersCompanies
